<template>
  <div class="conflitos-detalhe">
    <div v-if="item && item.log_erro && item.log_erro.length" class="conflitos-detalhe__section">
      <div class="conflitos-detalhe__title conflitos-detalhe__title--erro">
        <i class="fa fa-times-circle"></i> Erro ({{ item.log_erro.length }})
      </div>

      <div v-for="(err, key) in item.log_erro" :key="'erro-' + key" class="conflitos-detalhe__item conflitos-detalhe__item--erro">
        <span v-if="err['risco_vinculo']">
          <p class="conflitos-detalhe__hint"><b>RISCO SEM VÍNCULO COM ESOCIAL</b></p>
          <p class="conflitos-detalhe__path">Acesse o menú Configurações &gt; Riscos para atualizar corretamente os riscos abaixo.</p>
          <p v-for="(risco, i) in err['risco_vinculo']" :key="i" class="conflitos-detalhe__line">{{ risco }}</p>
        </span>

        <span v-else-if="err['exame_vinculo']">
          <p class="conflitos-detalhe__hint"><b>EXAME SEM VÍNCULO COM ESOCIAL OU COM PROBLEMA DE CADASTRO</b></p>
          <p class="conflitos-detalhe__path">Acesse o menú Configurações &gt; Exames para atualizar corretamente os exames abaixo.</p>
          <p v-for="(exame, i) in err['exame_vinculo']" :key="i" class="conflitos-detalhe__line">{{ exame }}</p>
        </span>

        <span v-else-if="err['cadastro_medico']">
          <p class="conflitos-detalhe__hint"><b>CADASTRO DO MÉDICO EXAMINADOR INVÁLIDO</b></p>
          <p class="conflitos-detalhe__path">Acesse o menú Configurações &gt; Médicos Examinadores para atualizar corretamente o médico da consulta.</p>
          <p v-for="(exame, i) in err['cadastro_medico']" :key="i" class="conflitos-detalhe__line">{{ exame }}</p>
        </span>

        <span v-else-if="err['cadastro_funcionario']">
          <p class="conflitos-detalhe__hint"><b>CADASTRO DO TRABALHADOR INVÁLIDO</b></p>
          <p class="conflitos-detalhe__path">Acesse o menú Empresa &gt; Funcionários para atualizar corretamente os dados do trabalhador.</p>
          <p v-for="(risco, i) in err['cadastro_funcionario']" :key="i" class="conflitos-detalhe__line">{{ risco }}</p>
        </span>

        <span v-else-if="err['cadastro_reg_amb']">
          <p class="conflitos-detalhe__hint"><b>CADASTRO RESPONSÁVEL TÉCNICO INVÁLIDO</b></p>
          <p class="conflitos-detalhe__path">Acesse o menú PPRA/PGR &gt; Gerenciar para atualizar corretamente os dados do responsável pelo PGR.</p>
          <p v-for="(posicoes, i) in err['cadastro_reg_amb']" :key="i" class="conflitos-detalhe__line">
            <b v-if="posicoes.posicao">{{ posicoes.posicao }}:</b>
            <span v-if="posicoes.msg">{{ posicoes.msg }}</span>
            <span v-else>{{ posicoes }}</span>
          </p>
        </span>

        <span v-else-if="err['cadastro_ppp_fdt']">
          <p class="conflitos-detalhe__hint"><b>CADASTRO DA EXPOSIÇÃO A FATORES DE RISCOS INVÁLIDO</b></p>
          <p class="conflitos-detalhe__path">Acesse o menú LTCAT &gt; Gerenciar para atualizar corretamente as medições do LTCAT desse trabalhador.</p>
          <p v-for="(posicoes, i) in err['cadastro_ppp_fdt']" :key="i" class="conflitos-detalhe__line">
            <span v-if="posicoes.msg">{{ posicoes.msg }}</span>
            <span v-else>{{ posicoes }}</span>
          </p>
        </span>

        <span v-else-if="err['erro_cadastro_fdt']">
          <p class="conflitos-detalhe__hint"><b>CADASTRO DA FRENTE DE TRABALHO INVÁLIDO</b></p>
          <p class="conflitos-detalhe__path">Acesse o menú Empresa &gt; Editar &gt; Frente de Trabalho &gt; Editar para atualizar corretamente a frente de trabalho.</p>
          <p v-for="(risco, i) in err['erro_cadastro_fdt']" :key="i" class="conflitos-detalhe__line">{{ risco }}</p>
        </span>

        <span v-else-if="err['cadastro_sem_risco']">
          <p class="conflitos-detalhe__hint"><b>NENHUM RISCO FOI ENCONTRADO</b></p>
          <p class="conflitos-detalhe__path">Acesse o menú PCMSO &gt; Gerenciar para atualizar corretamente o documento PPRA ou PCMSO.</p>
          <p v-for="(risco, i) in err['cadastro_sem_risco']" :key="i" class="conflitos-detalhe__line">{{ risco }}</p>
        </span>

        <span v-else-if="err['error_cadastro_epi']">
          <p class="conflitos-detalhe__hint"><b>EPI CADASTRADO INCORRETAMENTE</b></p>
          <p class="conflitos-detalhe__path">Acesse o menú LTCAT &gt; Gerenciar para atualizar corretamente as medições no documento.</p>
          <template v-for="(epis, i) in err['error_cadastro_epi']">
            <p :key="i" class="conflitos-detalhe__line"><b>{{ i }}</b></p>
            <p v-for="epi in epis" :key="epi" class="conflitos-detalhe__line">{{ epi }}</p>
          </template>
        </span>

        <span v-else-if="err['cadastro']">
          <p class="conflitos-detalhe__hint"><b>CADASTRO INVÁLIDO</b></p>
          <p v-for="(risco, i) in err['cadastro']" :key="i" class="conflitos-detalhe__line">{{ risco }}</p>
        </span>

        <span v-else-if="err['cadastro_abs']">
          <p class="conflitos-detalhe__hint"><b>CADASTRO DO ABSENTEÍSMO INVÁLIDO</b></p>
          <p class="conflitos-detalhe__path">Acesse o menú Absenteísmo &gt; Gerenciar para atualizar corretamente o registro que está com erro.</p>
          <p v-for="(risco, i) in err['cadastro_abs']" :key="i" class="conflitos-detalhe__line">{{ risco }}</p>
        </span>

        <span v-else-if="err['erro_cadastro_setor']">
          <p class="conflitos-detalhe__hint"><b>CADASTRO DO GHE (SETOR) INCORRETO</b></p>
          <p class="conflitos-detalhe__path">Acesse o menú PPRA/PGR &gt; Gerenciar para atualizar corretamente o GHE (Setor) em questão.</p>
          <p v-for="(risco, i) in err['erro_cadastro_setor']" :key="i" class="conflitos-detalhe__line">{{ risco }}</p>
        </span>

        <span v-else-if="err['erro_cadastro_atividade_funcao']">
          <p class="conflitos-detalhe__hint"><b>DESCRIÇÃO DE ATIVIDADES DA FUNÇÃO NÃO INFORMADA</b></p>
          <p class="conflitos-detalhe__path">Acesse o menú PPRA/PGR &gt; Gerenciar, selecione o GHE (Setor) indicado e preencha a descrição de atividades da função do trabalhador.</p>
          <p v-for="(risco, i) in err['erro_cadastro_atividade_funcao']" :key="i" class="conflitos-detalhe__line">{{ risco }}</p>
        </span>

        <span v-else-if="err['erro_cadastro_fator_risco']">
          <p class="conflitos-detalhe__hint"><b>FATOR DE RISCO SEM DESCRIÇÃO DA METODOLOGIA</b></p>
          <p class="conflitos-detalhe__path">Acesse o menú Configurações &gt; Fatores de Risco para preencher a descrição da metodologia do fator de risco indicado.</p>
          <p v-for="(risco, i) in err['erro_cadastro_fator_risco']" :key="i" class="conflitos-detalhe__line">
            {{ risco.msg ? risco.msg : risco }}
          </p>
        </span>

        <span v-else-if="err['erro_cadastro_epi_risco']">
          <p class="conflitos-detalhe__hint"><b>EPI NÃO CADASTRADO PARA O RISCO</b></p>
          <p class="conflitos-detalhe__path">Acesse o menú PPRA/PGR &gt; Gerenciar, selecione o GHE (Setor) e vincule um ou mais EPIs ao risco indicado.</p>
          <p v-for="(risco, i) in err['erro_cadastro_epi_risco']" :key="i" class="conflitos-detalhe__line">
            {{ risco.msg ? risco.msg : risco }}
          </p>
        </span>

        <span v-else-if="err['erro_cadastro_reg_amb']">
          <p class="conflitos-detalhe__hint"><b>NENHUMA MEDIÇÃO FOI CADASTRADO PARA ESSE LTCAT</b></p>
          <p class="conflitos-detalhe__path">Acesse o menú Ltcat &gt; Gerenciar para atualizar corretamente as medições do GHE (Setor) do funcionário em questão.</p>
        </span>

        <span v-else><p class="conflitos-detalhe__line">{{ err }}</p></span>
      </div>
    </div>

    <div v-if="item && item.log_warning && item.log_warning.length" class="conflitos-detalhe__section">
      <div class="conflitos-detalhe__title conflitos-detalhe__title--warning">
        <i class="fa fa-exclamation-circle"></i> Pontos de Atenção ({{ item.log_warning.length }})
      </div>

      <div v-for="(warn, key) in item.log_warning" :key="'warn-' + key" class="conflitos-detalhe__item conflitos-detalhe__item--warning">
        <span v-html="warn"></span>
      </div>
    </div>

    <div v-if="!hasContent" class="conflitos-detalhe__empty">Nenhum conflito encontrado.</div>
  </div>
</template>

<script>
export default {
  name: "conflitos-detalhe",
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  computed: {
    hasContent() {
      return !!(
        this.item &&
        ((this.item.log_erro && this.item.log_erro.length) || (this.item.log_warning && this.item.log_warning.length))
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.conflitos-detalhe {
  font-size: 11px;
  color: #374151;

  &__section + &__section {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #eef0f2;
  }

  &__title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    margin-bottom: 8px;

    &--erro {
      color: #c0392b;
    }

    &--warning {
      color: #a8791f;
    }
  }

  &__item {
    padding: 6px 0;

    & + & {
      border-top: 1px dashed #eef0f2;
    }
  }

  &__hint {
    color: #374151;
    margin: 0 0 2px;
  }

  &__path {
    color: #8a8f98;
    font-size: 10px;
    font-style: italic;
    margin: 0 0 4px;
  }

  &__line {
    margin: 0 0 2px;
    padding-left: 8px;
  }

  &__empty {
    color: #8a8f98;
    text-align: center;
    padding: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// conflitos-detalhe.vue?405dd213